import React, {
  useCallback,
  useState,
  useMemo,
  useEffect,
} from 'react';

import { Form } from '@unform/web';
import { isEmpty, isArray, isUndefined } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { format, subDays, setHours, setMinutes, setSeconds, parseISO } from 'date-fns';
import { Select } from '~/components/Form';
// import { DateTime, DateTime2 } from '~/componentslocal'
import { t, parseDateString } from '~/helpers';
import { getEveryMonth, getYearsInterval } from '~/helpers/dateTime';
import api from '~/services/api';

import * as S from './styles';

// import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { FormHelperText } from '@material-ui/core';
import {
  KeyboardDateTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { useField } from '@unform/core';
import { isEqual, includes, isFunction, isNull } from 'lodash';
import moment from 'moment';
// import PropTypes from 'prop-types';

import { canURL } from '~/helpers';


export function DateTime({
  name,
  label,
  disabled,
  time,
  getValue,
  serialize,
  nullable,
  ...rest
}) {
  const inputRef = React.useRef(null);
  const permission = isEqual(canURL(), { read: true });

  const [picker, setPicker] = React.useState(nullable ? null : moment());
  const [inputError, setInputError] = React.useState(false);
  // const [formatDateTime, setFormatDateTime] = React.useState('YYYY-MM-DD HH:mm:ss')

  const {
    fieldName,
    defaultValue,
    registerField,
    error,
    clearError,
  } = useField(name);
  const { language } = useSelector((state) => state.user);

  const messagesKeyboard = useMemo(
    () => [
      'Formato de data inválido',
      'A data não deve ser posterior à data máxima',
      'A data não deve ser anterior à data mínima',
    ],
    []
  );

  // Modify format date and time component
  const formatDateTime = React.useMemo(() => {
    if (language === 'pt-BR') {
      if (time) return 'DD/MM/YYYY HH:mm:ss';

      return 'DD/MM/YYYY';
    }

    if (time) return 'YYYY-MM-DD HH:mm:ss';

    return 'YYYY-MM-DD';
  }, [language, time]);


  // Change Picker
  const handleChangePicker = React.useCallback((value) => {
    setPicker(value);
  }, []);

  // Toggle error component
  const handleChangeInput = React.useCallback(() => {
    if (isNull(picker)) {
      getValue(null);
    } else {
      getValue(
        String(picker._d).toLowerCase() == 'invalid date' ? picker._i : picker.format(formatDateTime)
      );
    }

    inputRef.current.value = isFunction(serialize)
      ? serialize(picker)
      : picker.format(formatDateTime);
  }, [picker, formatDateTime]);

  React.useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  React.useEffect(() => {
    if (defaultValue) {
      const convertDate = moment(defaultValue, formatDateTime);

      inputRef.current.value = isFunction(serialize)
        ? serialize(convertDate)
        : convertDate.format(formatDateTime);
      setPicker(convertDate);
    } else {
      inputRef.current.value = isFunction(serialize)
        ? serialize(moment())
        : moment().format(formatDateTime);
    }
  }, [defaultValue, formatDateTime, time]);

  React.useEffect(() => {
    if (
      picker
    ) {
      handleChangeInput();
    } else {
      inputRef.current.value = null;
    }
  }, [picker]);

  React.useEffect(() => {
    if (disabled) clearError();
  }, [disabled]);

  return (
    <S.Wrapper>
      {time ? (
        <KeyboardDateTimePicker
          fullWidth
          error={!!error || inputError}
          value={picker}
          ampm={false}
          onChange={handleChangePicker}
          label={label}
          inputVariant="outlined"
          size="small"
          invalidDateMessage={messagesKeyboard[0]}
          maxDateMessage={messagesKeyboard[1]}
          minDateMessage={messagesKeyboard[2]}
          {...rest}
          disabled={permission || disabled}
          format={formatDateTime}
          onError={(err) => setInputError(includes(messagesKeyboard, err))}
          onFocus={clearError}
        />
      ) : (
        <KeyboardDatePicker
          fullWidth
          error={!!error || inputError}
          value={picker}
          onChange={handleChangePicker}
          label={label}
          inputVariant="outlined"
          size="small"
          invalidDateMessage={messagesKeyboard[0]}
          maxDateMessage={messagesKeyboard[1]}
          minDateMessage={messagesKeyboard[2]}
          {...rest}
          disabled={permission || disabled}
          format={formatDateTime}
          onError={(err) => setInputError(includes(messagesKeyboard, err))}
          onFocus={clearError}
        />
      )}

      <input type="hidden" ref={inputRef} />
      {!!error && <FormHelperText error>{error}</FormHelperText>}
    </S.Wrapper>
  );
}

DateTime.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  time: PropTypes.bool,
  getValue: PropTypes.func,
  serialize: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  nullable: PropTypes.bool,
};

DateTime.defaultProps = {
  disabled: false,
  time: false,
  getValue: () => undefined,
  serialize: false,
  nullable: false,
};


const TypeFilters = React.forwardRef((props, formRef) => {
  const {
    options,
    initials,
    onCallback,
    validate,
    numberOfYears,
    initialURL,
    finalURL,
    code,
  } = props

  const [typeSelect, setTypeSelect] = useState(null);
  const [shift, setShift] = useState({ initial: [], final: [] });
  const [errorsObject, setErrorsObject] = useState({})
  const [fieldsValues, setFieldsValues] = useState({})
  const [data_inicio, setData_inicio] = useState(false)
  const [data_fim, setData_fim] = useState(false)
  const [turnoInicio, setTurnoInicio] = useState(false)
  const [turnoFinal, setTurnoFinal] = useState(false)
  const [turnosCod, setTurnosCod] = useState({ turno_inicio_cod: 0, turno_fim_cod: 0 })
  const [dataInicialAno, setDataInicialAno] = useState('')
  const [dataFinalAno, setDataFinalAno] = useState('')
  const [initialsData, setInitialsData] = useState(initials)


  const optionsArray = useMemo(
    () => [
      { label: t('s.geral.filtro.periododatahora'), value: 1 },
      { label: t('s.geral.filtro.periododata'), value: 2 },
      { label: t('s.geral.filtro.periodomesanoiniciofim'), value: 3 },
      { label: t('s.geral.filtro.periodomesano'), value: 4 },
      { label: t('s.geral.filtro.turno'), value: 5 },
    ],
    []
  );

  const legend = useMemo(
    () =>
      typeSelect
        ? optionsArray.find((o) => o.value === typeSelect).label
        : null,
    [typeSelect, optionsArray]
  );



  const handleSendWithModification = useCallback((value, fieldName = '') => {
    if (fieldName == 'turno_fim' || fieldName == 'turno_inicio') {
      let turno_cod = fieldName + '_cod'
      let turno_value = value;
      let array_turno = fieldName == 'turno_inicio' ? shift.initial.find(
        (s) => s.value === turno_value
      ) : shift.final.find(
        (s) => s.value === turno_value)

      setTurnosCod((old) => ({ ...old, [turno_cod]: turno_value }))
      fieldName == 'turno_inicio' ? setTurnoInicio(array_turno) : setTurnoFinal(array_turno)

    } else if (value != undefined) {

      if (typeSelect == 1) {
        fieldName == 'datahora_inicio' ? setData_inicio(value) : setData_fim(value)
      } else if (typeSelect == 2) {
        fieldName == 'data_inicio' ? setData_inicio(value) : setData_fim(value)
      } else if (typeSelect == 5) {
        fieldName == 'data_inicio_turno' ? setData_inicio(value) : setData_fim(value)
      }
      formRef.current.setFieldValue(fieldName, value)


    }
  }, [formRef, shift, typeSelect]);

  // const handleSetData = useCallback(() => {

  //   if (fieldsValues.ano_inicio && fieldsValues.mes_inicio) {
  //     let data = format(
  //       new Date(fieldsValues.ano_inicio, fieldsValues.mes_inicio, 1),
  //       'dd/MM/yyyy HH:mm:ss'
  //     )
  //   }
  //   if (fieldsValues.ano_fim && fieldsValues.mes_fim) {

  //   }
  // }, [fieldsValues])

  // useEffect(() => {
  //   setFieldsValues({})
  //   setTurnoInicio(false)
  //   setTurnoFinal(false)
  //   setShift({ initial: [], final: [] })
  //   setTurnosCod({ turno_inicio_cod: 0, turno_fim_cod: 0 })
  // }, [typeSelect])

  useEffect(() => {
    if (typeSelect == 5) {
      const data = formRef.current.getData()
      onCallback({ ...data, data_inicio_turno: data_inicio, data_fim_turno: data_fim, turno_inicio: turnoInicio, turno_fim: turnoFinal })
    } else if (typeSelect == 3) {
      // const data = formRef.current.getData()
      // onCallback({ ...data, ...fieldsValues })
    } else if (typeSelect == 1) {
      const data = formRef.current.getData()
      onCallback({ ...data, datahora_inicio: data_inicio, datahora_fim: data_fim })
    } else if (typeSelect == 2) {
      const data = formRef.current.getData()
      onCallback({ ...data, data_inicio: data_inicio, data_fim: data_fim })
    }
  }, [fieldsValues, typeSelect, formRef, errorsObject, turnoInicio, turnoFinal, dataInicialAno, dataFinalAno, data_inicio, data_fim])



  useEffect(() => {
    if (typeSelect == 2) {
      setInitialsData({
        tipo: 2,
        data_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy'),
        data_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy')
      })
    } else if (typeSelect == 1) {
      setInitialsData({
        tipo: 1,
        datahora_inicio: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy HH:mm:ss'),
        datahora_fim: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy HH:mm:ss')
      })
    } else if (typeSelect == 5) {
      setInitialsData({
        tipo: 5,
        data_inicio_turno: format(setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0), 'dd/MM/yyyy'),
        data_fim_turno: format(setSeconds(setMinutes(setHours(new Date(), 23), 59), 59), 'dd/MM/yyyy')
      })

    }
  }, [typeSelect])


  useEffect(() => {
    if (typeSelect == 5) {
      if (turnosCod.turno_inicio_cod != 0) {
        let turnoObjct = shift.initial.find(s => s.value == turnosCod.turno_inicio_cod)
        setTurnoInicio(isUndefined(turnoObjct) ? false : turnoObjct)
      }
      if (turnosCod.turno_final_cod != 0) {
        let turnoObjct = shift.final.find(s => s.value == turnosCod.turno_fim_cod)
        setTurnoFinal(isUndefined(turnoObjct) ? false : turnoObjct)
      }
    }
  }, [shift, turnosCod, typeSelect])

  useEffect(() => {
    if (typeSelect == 5) {
      handleGetShift(data_inicio, 'initial')
      handleGetShift(data_fim, 'final')
    }
  }, [code])

  const handleGetShift = useCallback(
    async (value, position) => {
      try {
        const URL = position === 'initial' ? initialURL : finalURL;
        const query =
          position === 'initial'
            ? { datahorainicio: `${value} 00:00:00` }
            : { datahorafinal: `${value} 00:00:00` };

        const { data } = await api.get(URL, {
          params: { ...query, codigoposto: code },
        });


        if (data.length > 0) {
          setShift((state) => ({
            ...state,
            [position]: data.map((item) => ({
              ...item,
              label: `${item.turn_num_turn} - ${position === 'initial' ? item.hora_ini : item.hora_fim
                }`,
              value: item.turn_num_turn,
            })),
          }));

        } else {
          setShift((state) => ({
            ...state,
            [position]: []
          }))

        }
      } catch (err) {
        setShift((state) => ({
          ...state,
          [position]: []
        }))
      }


    },
    [initialURL, finalURL, code, formRef]
  );



  const renderInputs = useCallback(
    (value) => {
      // Período de Data/Hora
      if (value === 1)
        return (
          <>
            <DateTime
              time
              name="datahora_inicio"
              label={t('s.cadastro.contrato.datainicialcontrato')}
              getValue={(val) => handleSendWithModification(val, 'datahora_inicio')}
            />

            <DateTime
              time
              name="datahora_fim"
              label={t('s.cadastro.contrato.datafinalcontrato')}
              getValue={(val) => handleSendWithModification(val, 'datahora_fim')}
            />
          </>
        );

      // Período Data
      if (value === 2)
        return (
          <>
            <DateTime
              name="data_inicio"
              label={t('s.cadastro.contrato.datainicialcontrato')}
              getValue={(val) => handleSendWithModification(val, 'data_inicio')}


            />

            <DateTime
              name="data_fim"
              label={t('s.cadastro.contrato.datafinalcontrato')}
              getValue={(val) => handleSendWithModification(val, 'data_fim')}

            />
          </>
        );

      // Período mês/ano inicio e fim
      if (value === 3) {
        const months = getEveryMonth().map((month, key) => ({
          value: key + 1,
          label: month,
        }));

        const years = getYearsInterval(numberOfYears).map((year) => ({
          value: year,
          label: year,
        }));

        return (
          <>
            <Select
              name="mes_inicio"
              label={t('s.geral.filtro.mesinicio')}
              options={months}
              getValue={(val) => handleSendWithModification(val, 'mes_inicio')}
            />

            <Select
              name="ano_inicio"
              label={t('s.geral.filtro.anoinicio')}
              options={years}
              getValue={(val) => handleSendWithModification(val, 'ano_inicio')}
            />

            <Select
              name="mes_fim"
              label={t('s.geral.filtro.mesfim')}
              options={months}
              getValue={(val) => handleSendWithModification(val, 'mes_fim')}
            />

            <Select
              name="ano_fim"
              label={t('s.geral.filtro.anofim')}
              options={years}
              getValue={(val) => handleSendWithModification(val, 'ano_fim')}
            />
          </>
        );
      }

      // Período Mês e Ano
      if (value === 4) {
        const months = getEveryMonth().map((month, key) => ({
          value: key + 1,
          label: month,
        }));

        const years = getYearsInterval(numberOfYears).map((year) => ({
          value: year,
          label: year,
        }));

        return (
          <>
            <Select
              name="mes"
              label={t('s.geral.filtro.mes')}
              options={months}
              getValue={handleSendWithModification}
            />

            <Select
              name="ano"
              label={t('s.geral.filtro.ano')}
              options={years}
              getValue={handleSendWithModification}
            />
          </>
        );
      }

      // Turno
      if (value === 5)
        return (
          <>
            <DateTime
              name="data_inicio_turno"
              label={t('s.cadastro.contrato.datainicialcontrato')}
              getValue={(val) => {
                handleGetShift(val, 'initial')
                handleSendWithModification(val, 'data_inicio_turno')
              }}
            />

            <Select
              name="turno_inicio"
              label={t('s.geral.filtro.turnoinicio')}
              options={shift.initial}
              onChange={
                (val) => {
                  handleSendWithModification(val.target.value, 'turno_inicio')
                }
              }
            />

            <DateTime
              name="data_fim_turno"
              label={t('s.cadastro.contrato.datafinalcontrato')}
              getValue={(val) => {
                handleGetShift(val, 'final')
                handleSendWithModification(val, 'data_fim_turno')
              }}
            />

            <Select
              name="turno_fim"
              label={t('s.geral.filtro.turnofim')}
              options={shift.final}
              onChange={
                (val) => {
                  handleSendWithModification(val.target.value, 'turno_fim')
                }
              }
            />
          </>
        );
    },
    [numberOfYears, shift, typeSelect, validate]
  );




  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current.setErrors({});
        setErrorsObject({})

        const sendData = formRef.current.getData();



        if (sendData.turno_inicio) {
          sendData.turno_inicio = shift.initial.find(
            (s) => s.value === sendData.turno_inicio
          );
        }

        if (sendData.turno_fim) {
          sendData.turno_fim = shift.final.find(
            (s) => s.value === sendData.turno_fim
          );
        }
        onCallback(sendData);

        const defaultSchema = Yup.object().shape({
          tipo: Yup.number().required('Selecione uma opção de data')
        })
        await defaultSchema.validate({ tipo: typeSelect }, {
          abortEarly: false,
        });

        if (data.tipo != undefined) {

          const isValid = validate.filter((val) => val.field === typeSelect);
          const schemaValidate = isEmpty(isValid) ? {} : isValid[0].shape;

          if (data.tipo == 5) {
            const testData = {
              ...data,
              data_inicio: data.data_inicio + ' 00:00:00',
              data_fim: data.data_fim + ' 23:59:59'
            }

            await schemaValidate.validate(testData, {
              abortEarly: false,
            });

          } else {
            await schemaValidate.validate(fieldsValues, {
              abortEarly: false,
            });
          }

        }

      } catch (err) {
        console.log(err)

      }
    },
    [validate, typeSelect, shift, fieldsValues, formRef]
  );


  useEffect(() => {
    if (options.length === 1) setTypeSelect(options[0].value);
  }, [options]);

  return (
    <Form ref={formRef} initialData={initialsData} style={{ margin: '10px 0' }}>
      {options.length > 1 && (
        <Select
          name="tipo"
          label={t('s.geral.filtro.tipofiltro')}
          getValue={(value) => {
            setTypeSelect(Number(value))
            setFieldsValues({})
            setTurnoInicio(false)
            setTurnoFinal(false)
            setShift({ initial: [], final: [] })
            setTurnosCod({ turno_inicio_cod: 0, turno_fim_cod: 0 })
          }}
          options={isEmpty(options) ? optionsArray : options}
        />
      )}

      {optionsArray.map((o) => o.value).includes(typeSelect) && (
        <S.GroupInput grid={[1, 3, 4, 5].includes(typeSelect)}>
          <legend>{legend}</legend>
          <div className="__container">{renderInputs(typeSelect)}</div>
        </S.GroupInput>
      )}
    </Form>
  );
})

export default TypeFilters

TypeFilters.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    })
  ),
  numberOfYears: PropTypes.number,
  initials: PropTypes.objectOf(PropTypes.any),
  onCallback: PropTypes.func.isRequired,
  validate: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.number.isRequired,
      shape: PropTypes.objectOf(PropTypes.any).isRequired,
    })
  ),
  validateErrors: PropTypes.func,
  initialURL: PropTypes.string,
  finalURL: PropTypes.string,
  code: PropTypes.string,
};

TypeFilters.defaultProps = {
  numberOfYears: 20,
  options: [],
  validate: [],
  initials: {},
  initialURL: '',
  finalURL: '',
  code: '',
};
